/**
 * DO NOT EDIT.
 *
 * This is Relay generated artifact.
 *
 * Please reach out to #jsm-cloud-megatron for any questions.
 *
 * @generated SignedSource<<0515b2035645862295c6fd8cd9244866>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type EAPConversationInputUser$data = {
  readonly accountId: string;
  readonly " $fragmentType": "EAPConversationInputUser";
};
export type EAPConversationInputUser$key = {
  readonly " $data"?: EAPConversationInputUser$data;
  readonly " $fragmentSpreads": FragmentRefs<"EAPConversationInputUser">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EAPConversationInputUser",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "accountId",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": "__isUser"
};

(node as any).hash = "bc614ef280595e859832a5c23ad263f8";

export default node;
